import NoValue from 'Components/Atoms/NoValue/NoValue';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useOuterClick } from 'Services/helpers';
import styles from './TextField.module.sass';

const TextField = ({isEdit, value, onChange, placeholder}) => {
    const [isFocused, setFocused] = useState(false);
    const inputRef: any = useRef();
    const innerRef = useOuterClick(() => setFocused(false));

    useEffect(() => {
        if (!isFocused) return;
        inputRef?.current?.focus();
    }, [isFocused]);

    if (!isEdit) {
        if (!value || value?.length == 0) return <NoValue />;

        if (typeof value == 'string') {
            const isEmail = value?.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            if (isEmail) {
                return <Link to="#" onClick={(e) => {
                    e.preventDefault();
                    window.location.href = `mailto:${value}`;
                }}><a>{value}</a></Link>;
            }

            let urlPattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
                '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
            if (!!urlPattern.test(value)) return <a href={value} target="_blank">{value}</a>;
        }

        return value;
    }

    return <div className={`${styles['textfield']} ${isFocused ? styles['textfield--active'] : ''}`}
        onClick={() => setFocused(true)}
        ref={innerRef}
    >
        <div className={`${styles['textfield__content']}`}>
            <input
                placeholder={placeholder}
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                onBlur={() => onChange(value?.trim())}
                ref={inputRef}
            />
        </div>
    </div>;
}

export default TextField;